import { render, staticRenderFns } from "./wtSvgAnimation.component.vue?vue&type=template&id=0c35e087&"
import script from "./wtSvgAnimation.component.vue?vue&type=script&lang=js&"
export * from "./wtSvgAnimation.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports